import { createSlice } from '@reduxjs/toolkit';
import { ANON_USER_ENTITLEMENTS, DIGITAL_SFID, LOGGED_USER_ENTITLEMENTS } from '../../config/authentication';

interface AuthorizationState {
    selectedProfiles: string[];
    currentLoggedUser?: CurrentLoggedUser;
    entitlements: string[];
}

export interface CurrentLoggedUser {
    authenticatorName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    properties?: {
        name: string;
        description: string | null;
        value: string;
        id: number;
        userId: number;
    }[];
    id?: string;
    username?: string;
    domain?: string;
    sfid?: {
        status: string;
        data: {
            id: string;
            fullName: string;
            externalReference: {
                externalReferenceType: string;
                name: string;
            };
        };
    };
}

const initialAuthorizationState: AuthorizationState = {
    selectedProfiles: ['APP-PT-ONEX-PRE-CTO_PROJETOS_TOTAL'], //TODO Review this default profile
    currentLoggedUser: {
        sfid: { status: 'success', data: DIGITAL_SFID }
    },
    entitlements: ANON_USER_ENTITLEMENTS
};

const authorizationReducer = createSlice({
    initialState: initialAuthorizationState,
    name: 'authorization',
    reducers: {
        setSelectedProfiles: (state, action) => {
            state.selectedProfiles = action.payload;
        },
        setCurrentLoggedUser: (state, action) => {
            state.currentLoggedUser = { ...action.payload, sfid: { status: 'success', data: DIGITAL_SFID } };
            state.entitlements = LOGGED_USER_ENTITLEMENTS;
        },
        clearAuthentication: (state) => {
            state.currentLoggedUser = { ...initialAuthorizationState.currentLoggedUser };
            state.entitlements = ANON_USER_ENTITLEMENTS;
        },
        setEntitlements: (state, action: { payload: string[] }) => {
            state.entitlements = action.payload;
        }
    }
});

export const { setSelectedProfiles, setCurrentLoggedUser, clearAuthentication, setEntitlements } =
    authorizationReducer.actions;

export default authorizationReducer;
